
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/single-axis-solar-tracker",
      function () {
        return require("private-next-pages/single-axis-solar-tracker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/single-axis-solar-tracker"])
      });
    }
  